<template>
	<div>
		<section class="heading">
			<h1 class="title">{{ title }}</h1>
			<button @click="$router.back()" class="btn btn-link btn-lg btn-cancel" :disabled="isLoading">
				Back
			</button>
		</section>
		<form @submit="e => { e.preventDefault(); onSubmit(fields); }">
			<div class="row">
				<div class="col-sm-12">
					<div class="box box-primary">
						<!-- <div class="box-header with-border">Service Data</div> -->
						<div class="box-body">
							<div class="row">
								<div class="col-xs-12 col-sm-4">
									<input-wrapper id="title" label="Proposal Title">
										<input v-model="fields.title" id="title" type="text" class="form-control" :disabled="isLoading" required>
									</input-wrapper>		
								</div>
								<div class="col-xs-12 col-sm-4">
									<input-wrapper id="number" label="Proposal No.">
										<input v-model="fields.number" id="number" type="text" class="form-control" :disabled="isLoading" required>
									</input-wrapper>
								</div>
								<div class="col-xs-12 col-sm-4">
									<input-wrapper id="date" label="Date">
										<input v-model="fields.date" id="date" type="date" class="form-control" :disabled="isLoading" required>
									</input-wrapper>
								</div>
							</div>

							<div class="row">
								<div class="col-xs-12 col-sm-8">
									<input-wrapper id="customer_id" label="Customer Name">
                                        <customer-dropdown :onChange="handleCustomerFilter" :selected="fields.customer"></customer-dropdown>
									</input-wrapper>
								</div>
								<div class="col-xs-12 col-sm-4">
									<input-wrapper id="expired_at" label="Expiry Date">
										<input v-model="fields.expired_at" id="expired_at" type="date" class="form-control" :disabled="isLoading" required>
									</input-wrapper>
								</div>
							</div>

							<div class="row">
								<div class="col-xs-12">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-detail-form">
                                            <thead>
                                                <tr>
                                                    <th width="50px"><add-button :onClick="addItem" /></th>
                                                    <th class="table-item-form table-min-width">Item</th>
                                                    <th class="table-min-width">Qty</th>
                                                    <th class="table-min-width">Price</th>
                                                    <th class="table-min-width">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in fields.items" :key="index">
                                                    <td>
                                                        <delete-button :onClick="() => removeItem(index)" />
                                                    </td>
                                                    <td>
                                                        <auto-complete 
                                                            v-model="item.name"
                                                            :list="masterService"
                                                            :onSelect="selectMasterService(index)"
                                                            placeholder="Service Name" /> <br />
                                                        <textarea 
                                                            v-model="item.description" rows="6"
                                                            class="form-control" placeholder="Service Description"/>
                                                    </td>
                                                    <td>
                                                        <input v-model="item.qty" type="number" class="form-control" required>
                                                    </td>
                                                    <td>
                                                        <money v-model="item.price" v-bind="money" class="form-control" required />
                                                    </td>
                                                    <td>
                                                        <money :value="calculateSubtotal(item.price, item.qty)" v-bind="money" class="form-control" disabled/>
                                                    </td>
                                                </tr>
                                                <tr class="no-border">
                                                    <td colspan="2" rowspan="3"> 
                                                        <input-wrapper label="Note">
                                                            <textarea v-model="fields.note" class="form-control" :disabled="isLoading" rows="5"/>
                                                        </input-wrapper>
                                                    </td>
                                                    <td colspan="2"> Subtotal </td>
                                                    <td class="text-right">
                                                        <money :value="subTotal" v-bind="money" class="form-control text-right" disabled/>
                                                    </td>
                                                </tr>
                                                <tr class="no-border">
                                                    <td colspan="2"> Discount </td>
                                                    <td>
                                                        <money v-model="fields.discount" v-bind="money" class="form-control text-right" required />
                                                    </td>
                                                </tr>
                                                <tr class="no-border">
                                                    <td colspan="2"> Grand Total </td>
                                                    <td>
                                                        <money :value="grandTotal" v-bind="money" class="form-control text-right" disabled />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
								</div>
							</div>

							<div class="row">
								<div class="col-xs-12">
									<div class="panel box box-success">
										<div class="box-header with-border">
											<h4 class="box-title">
												<a data-toggle="collapse" data-parent="#accordion" href="#paymentTermPanel" aria-expanded="false" class="collapsed text-green">
													Payment Term
												</a>
											</h4>
										</div>
										<div id="paymentTermPanel" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
											<div class="box-body">
												<div class="col-xs-9">
													<add-button :onClick="createMilestone" :disabled="isLoading" /> &nbsp; <h4 class="inline-title">Add Payment Term</h4>
												</div>
												<div class="col-xs-3">
													<b :class="{'text-red': errors.payment_term, 'pull-right': true}">Total: {{ totalPercent }}%</b>
												</div>
												<div class="col-xs-12">
													<span v-show="errors.payment_term" class="help-block text-red">
														{{ errors.payment_term }}
													</span>
													<payment-term
														:initialData="defaultPaymentTerm"
														:removeMilestone="removeMilestone"
														:isLoading="isLoading" />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-xs-12">
									<div class="panel box box-success">
										<div class="box-header with-border">
											<h4 class="box-title">
												<a data-toggle="collapse" data-parent="#accordion" href="#termPanel" aria-expanded="false" class="collapsed text-green">
													Term & Conditions
												</a>
											</h4>
										</div>
										<div id="termPanel" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
											<div class="box-body">
												<ckeditor 
													id="proposal_terms_template"
													class="form-control"
													v-model="fields.terms"
													:editor="editor"
													:config="editorConfig"
													:disabled="isLoading" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12 text-right">
					<button class="btn btn-primary btn-lg" :disabled="isLoading">
						<i class="fa fa-circle-o-notch fa-spin" v-show="isLoading"></i>
						{{ submitTxt }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import { Money } from 'v-money';
import { defaultItemFields } from "./helpers";
import { moneyTemplate, formatPrice } from '../../helpers';
import InputWrapper from "../InputWrapper.vue";
import AutoComplete from '../AutoComplete.vue';
import AddButton from '../AddButton.vue';
import DeleteButton from '../DeleteButton.vue';
import PaymentTerm from '../settings/PaymentTerm.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import editorConfig from '../../editor-config';
import CustomerDropdown from "../CustomerDropdown.vue";

export default {
	components: { InputWrapper, Money, AutoComplete, AddButton, DeleteButton, vSelect, PaymentTerm, ckeditor: CKEditor.component, CustomerDropdown },
	props: {
		title: {
			type: String,
			required: true,
		},
		submitTxt: {
			type: String,
			required: true,
		},
		onSubmit: {
			type: Function,
			required: true,
		},
		masterService: {
			type: Array,
			required: true,
		},
		defaultPaymentTerm: {
			type: Array,
			required: true
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		fields: {
			type: Object,
			required: true,
		},
		errors: {
			type: Object,
			required: true,
		},
		totalPercent: {
			type: Number,
			required: true
		},
		createMilestone: {
			type: Function,
			required: true,
		},
		removeMilestone: {
			type: Function,
			required: true
		},
		defaultFormType: {
			type: String,
			default: "create",
			validator: (val) => ["create", "edit"].includes(val)
		}
	},
	computed: {
		grandTotal() {
			return this.subTotal - parseFloat(this.fields.discount);
		},
		subTotal() {
			var total = this.fields.items ? this.fields.items.reduce((subtotal, obj) => {
				return subtotal + (parseFloat(obj.qty) * obj.price);
			}, 0) : 0;
			return isNaN(total) ? 0 : total;
		},
	},
	data() {
		return {
			money: moneyTemplate(),
			editor: ClassicEditor,
			editorConfig,
		}
	},
	methods: {
        formatPrice,
        async handleCustomerFilter(customer) {
            this.fields.customer = (customer ? customer : "");
        },
		selectMasterService(index) {
			return selected => {
				let copyFrom = this.masterService.find(item => {
					return item.id == selected.value;
				});
				this.fields.items[index].name = copyFrom.name;
				this.fields.items[index].description = copyFrom.description;
				this.fields.items[index].price = copyFrom.price;
			}
		},
		addItem() {
			this.fields.items.push(defaultItemFields());
		},
		removeItem(index) {
			this.fields.items = this.fields.items.filter((item, i) => {
				return i != index;
			});
		},
		calculateSubtotal(price, qty) {
			return price * qty;
		},
	},
	watch: {
		masterService: {
			handler: function (nextProps, currentProps) {
				if (nextProps != currentProps && this.defaultFormType === "create") {
					this.addItem();
				}
			},
			deep: true
		},
		errors: function (nextProps, currentProps) {
			if (nextProps.payment_term !== null) {
				$("#paymentTermPanel").collapse("show");
			}
		}
	}
}
</script>

<style lang="less" scoped>

.inline-title, h4.box-title a {
	display: inline-block;
	font-weight: 700;
	font-size: 16px;
}

h4.box-title a {
	color: #005b97;
}

.inline-title {
	color: #333;
}

</style>
